import React, { Component } from "react";
import PropTypes from "prop-types";

import "../../../styles/components/utils/components/RadioCheck.scss";

class RadioCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div id="radioCheck">
        {!this.props.labelPos && (
          <label htmlFor={this.props.name}>{this.props.label}</label>
        )}
        <div className={this.props.disabled ? "check-container disabled" : "check-container"}>
          <input
            name={this.props.name}
            type="checkbox"
            checked={this.props.checked}
            onChange={this.props.onChange}
            disabled={this.props.disabled ? true : false}
          />
          <div className="check" />
        </div>
        {this.props.labelPos === "right" && (
          <label htmlFor={this.props.name}>{this.props.label}</label>
        )}
      </div>
    );
  }
}

RadioCheck.propTypes = {
  label: PropTypes.any,
  labelPos: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RadioCheck;
